import { useTranslation } from "react-i18next";
import type { RelationshipFieldset } from "@/entities/form-metadata";
import { Grid } from "@/shared/components/Grid";
import { AddNewFamilyMemberButton } from "./AddNewFamilyMemberButton";
import styles from "./AddNewFamilyMemberPanel.module.scss";

interface AddNewFamilyMemberPanelProps {
    fieldsets: RelationshipFieldset[];
    onItemAdded: (fieldset: RelationshipFieldset) => void;
}

export const AddNewFamilyMemberPanel = ({ fieldsets, onItemAdded }: AddNewFamilyMemberPanelProps) => {
    const { t } = useTranslation();

    return (
        <Grid.Container>
            <Grid.Field spanDesktop={12} spanTablet={12} spanMobile={12}>
                <ul aria-label={t("familyMember.addFamilyMemberLabel")} className={styles.container}>
                    <li aria-hidden="true" className={styles.label}>
                        {t("familyMember.addFamilyMemberLabel")}
                    </li>
                    {fieldsets.map((fs) => (
                        <li key={fs.relation}>
                            <AddNewFamilyMemberButton fieldset={fs} onItemAdded={onItemAdded} />
                        </li>
                    ))}
                </ul>
            </Grid.Field>
        </Grid.Container>
    );
};
